module.exports = __webpack_public_path__ + "0ee2d8c9dbe38540ec7006706d31c903.svg";